import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';

export default function isEditingEmailReminderEnabled(
    entrySource: EmailReminderEntrySource
): boolean {
    return (
        entrySource === EmailReminderEntrySource.FullCompose ||
        entrySource === EmailReminderEntrySource.ReadingPane
    );
}
